module.exports = __webpack_public_path__ + "media/images/interstitial/impact-47211d7060e316e010993e75b336138e.svg";